module.exports = __webpack_public_path__ + "static/why-time.300cee48.jpg";